import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-kfp3',
  templateUrl: './kfp3.component.html',
  styleUrls: ['./kfp3.component.scss']
})


export class Kfp3Component implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['kfp3'];
  }

}
